module.exports = __webpack_public_path__ + "static/media/privacy.6a9db158.svg";